import * as React from "react";
import { PricingResultPrice } from "./PricingResultPrice";
import './pricing-result.scss';
import { PricingResultBaseData } from "./PricingResultBaseData";
import { PricingResultHeader } from "./PricingResultHeader";
import { PricingResultCommission } from "./PricingResultCommission";
import { PricingResultDate } from "./PricingResultDate";
import { IPricingCalculatorResponse } from "src/services/interfaces/calculator/IPricingCalculatorResponse";
import { useContext } from "react";
import { AuthContext } from "src/components/context/AuthContext";
import { IPrecatorio } from "src/services/interfaces/IPrecatorio";
import { PricingResultPrecatorio } from "./PricingResultPrecatorio";

interface IPricingResultProps {
  title: string;
  result: IPricingCalculatorResponse;
  precatorio?: IPrecatorio;
  showAllData: boolean;
}

export const PricingResult: React.FC<IPricingResultProps> = ({ result, showAllData, title, precatorio }) => {
  const { currentUser } = useContext(AuthContext);
  return (
    <>
      <div className="region-container">
        <PricingResultHeader title={title} pricing={result} />
      </div>

      {result?.isRecalculateValid &&
        <>
          <div className="region-container">
            <PricingResultPrice pricing={result} showAllData={showAllData} />
          </div>
          {currentUser.permissions.userCanSeeCommission &&
            <div className="region-container">
              <PricingResultCommission pricing={result} showAllData={showAllData} />
            </div>
          }
          {precatorio &&
            <div className="region-container">
              <PricingResultPrecatorio precatorio={precatorio} pricing={result} showAllData={showAllData} />
            </div>
          }
          {showAllData &&
            <>
              <div className="region-container">
                <PricingResultBaseData pricing={result} />
              </div>
              <div className="region-container">
                <PricingResultDate pricing={result} />
              </div>
            </>
          }
        </>
      }
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/pricing-result/PricingResult.tsx